import {
  CARD_MACHINE_PAYMENT_REFERENCE_ID,
  CARD_MACHINE_DETAILS_OBJECT
} from './Index';

export const _cardMachineReferenceId = (
  cardMachineReferenceId: any
): any => async (dispatch: any) => {
  dispatch({
    type: CARD_MACHINE_PAYMENT_REFERENCE_ID,
    payload: {cardMachineReferenceId}
  });
};

export const _cardMachineDetailsObject = (
  cardMachineDetailsObject: any
): any => async (dispatch: any) => {
  dispatch({
    type: CARD_MACHINE_DETAILS_OBJECT,
    payload: {cardMachineDetailsObject}
  });
};
